import qs from 'qs';

/** @deprecated */
export const generateQuery = (params) => qs.stringify(params, { arrayFormat: 'brackets', skipNulls: true });
/** @deprecated */
export const generateUrl = (url, options) => {
  const { hash, ...params } = options || {};
  const query = generateQuery(params);
  return `${url}${query ? `?${query}` : ''}${hash ? `#${hash}` : ''}`;
};

/**
* Generates a URL by appending query parameters and hash to a base URL.
*
* Essentially a more robust version of `generateUrl()`.
*
* This method is more capable of handling edge cases,
* such as ensuring we do not have duplicate question marks
* in the generated URL.
*/
export const generateRobustUrl = (url, options) => {
  const { hash, ...params } = options || {};

  const urlObj = new URL(url);

  // Add new parameters to existing ones
  Object.entries(params || {}).forEach(([key, value]) => {
    urlObj.searchParams.set(key, value);
  });
  if (hash) {
    urlObj.hash = hash;
  }
  return urlObj.toString();
};

/**
 * @param {URLSearchParams} urlParams
 * @param {string[]} paramsToRemove
 */
export const removeUrlParams = (urlParams, paramsToRemove = []) => {
  for (const param of paramsToRemove) {
    urlParams.delete(param);
  }
  return urlParams;
};

export const isProductionEnvironmentUrl = (locationOrigin = '') => {
  const nonProdEnvironmentPattern = /(?:qaprod-|qa-|dev\.|ast-|staging-|localhost)/ig;

  locationOrigin = locationOrigin || window?.location?.origin || '';

  // if match for `nonProdEnvironmentPattern` is not found, we assume locationOrigin is a production url
  return !locationOrigin?.match?.(nonProdEnvironmentPattern);
};
